import { apiClient } from "@/lib/apiClient";

export const publicService = {
  async foundingStatus() { return (await apiClient.get("/public/founding-status")).data; },
  async siteConfig() { return (await apiClient.get("/public/site-config")).data; },
  async contact(payload) { return (await apiClient.post("/public/contact", payload)).data; },
};
